import { isLocal } from "@/utils/env-utils";

export function newBindTemplate(template, context) {
  if (!context) return template;

  return template.replace(/{{\s*([^}]+)\s*}}/g, function (match, key) {
    // find context
    const value = (() => {
      try {
        // match = {{a}}
        // key = a
        const keys = key.split(".");

        // access context
        let result = context;
        keys.forEach((k) => {
          result = result[k];
        });
        return result;
      } catch (error) {
        if (isLocal()) {
          console.warn("WARN_CAN_NOT_ACCESS_CONTEXT: maybe context is empty");
        }
        return null;
      }
    })();

    return value || "**";
  });
}

const parseTextSchema = (textTypeSchema, context) => {
  try {
    const { template, style } = textTypeSchema;

    if (!context) {
      console.warn("WARN_SKIP_PARSE_TEXT_SCHEMA: context is empty");
      return { text: template, style };
    }

    return {
      text: newBindTemplate(template, context),
      style,
    };
  } catch (error) {
    console.error(error);
    return textTypeSchema;
  }
};

export default parseTextSchema;
